import { Star, ToggleLeft, ToggleRight } from "lucide-react";
import { useState, useEffect } from "react";
import api from "../../services/api";

export default function LoyaltyToggle() {
  var enabledState = useState(false);
  var enabled = enabledState[0];
  var setEnabled = enabledState[1];
  var pointsState = useState(10);
  var points = pointsState[0];
  var setPoints = pointsState[1];
  var savingState = useState(false);

  useEffect(function() {
    api.get("/settings/loyalty").then(function(res) {
      setEnabled(res.data.enabled || false);
      setPoints(res.data.points_per_referral || 10);
    }).catch(function() {});
  }, []);

  async function toggle() {
    savingState[1](true);
    try {
      var newVal = !enabled;
      await api.put("/settings/loyalty", { enabled: newVal, points_per_referral: points });
      setEnabled(newVal);
    } catch(err) { console.error(err); }
    finally { savingState[1](false); }
  }

  async function savePoints(e) {
    var val = parseInt(e.target.value) || 10;
    setPoints(val);
    try {
      await api.put("/settings/loyalty", { enabled: enabled, points_per_referral: val });
    } catch(err) { console.error(err); }
  }

  var ToggleIcon = enabled ? ToggleRight : ToggleLeft;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4" data-testid="loyalty-toggle-card">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-[#F26A4B]/10 rounded-lg"><Star className="w-5 h-5 text-[#F26A4B]" /></div>
          <div>
            <p className="text-sm font-semibold text-[#0A2F3D]">Programa Fidelidade</p>
            <p className="text-xs text-gray-400">Pontos por indicacoes para clientes</p>
          </div>
        </div>
        <button onClick={toggle} disabled={savingState[0]} className="flex items-center gap-2" data-testid="loyalty-toggle-btn">
          <ToggleIcon className={"w-8 h-8 transition-colors " + (enabled ? "text-emerald-500" : "text-gray-300")} />
          <span className={"text-xs font-medium " + (enabled ? "text-emerald-600" : "text-gray-400")}>{enabled ? "Ativo" : "Inativo"}</span>
        </button>
      </div>
      {enabled && (
        <div className="mt-3 pt-3 border-t border-gray-100 flex items-center gap-3">
          <label className="text-xs text-gray-500">Pontos por indicacao convertida:</label>
          <input type="number" value={points} onChange={function(e) { setPoints(parseInt(e.target.value) || 10); }} onBlur={savePoints}
            className="w-20 px-2 py-1 text-sm border border-gray-200 rounded-lg text-center focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/20" min="1" max="1000"
            data-testid="loyalty-points-input" />
        </div>
      )}
    </div>
  );
}
